import { cloneDeep } from "lodash";
import {
  STEPS,
  DEFAULT_CARD_CONFIG,
  DEFAULT_BACKGROUND_CONFIG,
  DEFAULT_SIZE_CONFIG,
  DEFAULT_TEMPLATE_DATA,
  TEMPLATES,
  SIZES,
} from "./snapshotMaker.constants";

export const snapshotMakerInit = (initialData = {}) => {
  const template = cloneDeep(TEMPLATES[0] || {
    id: null,
    card: DEFAULT_CARD_CONFIG,
    background: DEFAULT_BACKGROUND_CONFIG,
  });
  const size = cloneDeep(SIZES[0] || DEFAULT_SIZE_CONFIG);

  return {
    step: STEPS.start,
    watermark: true,
    templateId: template.id,
    cardConfig: template.card,
    backgroundConfig: template.background,
    sizeConfig: size,
    templateData: cloneDeep(DEFAULT_TEMPLATE_DATA),
    result: null,
    ...initialData,
  };
};

export const snapshotMakerReducer = (state, action) => {
  switch (action.type) {
    case "setStep": {
      return {
        ...state,
        step: action.payload || STEPS.start,
      };
    }
    case "setWatermark": {
      return {
        ...state,
        watermark: !!action.payload,
      };
    }
    case "setTemplate": {
      if (action.payload) {
        const template = cloneDeep(action.payload);

        return {
          ...state,
          templateId: template.id,
          cardConfig: template.card,
          backgroundConfig: template.background,
        };
      }

      return state;
    }
    case "setSize": {
      return {
        ...state,
        sizeConfig: action.payload,
      };
    }
    case "setCard": {
      return {
        ...state,
        templateId: null,
        cardConfig: action.payload,
      };
    }
    case "updateCard": {
      return {
        ...state,
        templateId: null,
        cardConfig: {
          ...state.cardConfig,
          ...action.payload,
        },
      };
    }
    case "setBackground": {
      return {
        ...state,
        templateId: null,
        backgroundConfig: action.payload,
      };
    }
    case "updateBackground": {
      return {
        ...state,
        templateId: null,
        cardConfig: {
          ...state.backgroundConfig,
          ...action.payload,
        },
      };
    }
    case "setTemplateData": {
      return {
        ...state,
        templateData: action.payload,
      };
    }
    case "setResult": {
      return {
        ...state,
        result: action.payload,
      };
    }
    case "init": {
      return snapshotMakerInit(action.payload);
    }
    default: {
      return state;
    }
  }
};
